var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{attrs:{"two-line":""}},[_c('v-list-item-content',[_c('v-list-item-subtitle',[_vm._v(_vm._s(_vm.reply.field.title))]),_c('v-list-item-title',[_vm._v("\n            "+_vm._s(_vm.value)+"\n        ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }